<template>
<div class="top-users">
    <user-tile
        v-if="users[1]"
        :user="users[1]"
        position="silver"
    />

    <user-tile
        v-if="users[0]"
        :user="users[0]"
        position="gold"
    />

    <user-tile
        v-if="users[2]"
        :user="users[2]"
        position="bronze"
    />
</div>
</template>

<script>
import UserTile from "@/components/Leaderboard/User-Tile.vue";

export default {
    name: "TopUsers",
    props: {
        users: {
            type: Array,
            required: true
        },
    },
    components: {
        UserTile
    },
}
</script>

<style lang="scss" scoped>
.top-users {
    gap: 40px;
    display: flex;
    justify-content: center;

    @media only screen and (max-width: vars.get-map-value(vars.$breakpoints, tab)) {
        gap: 30px;
    }
    @media only screen and (max-width: vars.get-map-value(vars.$breakpoints, mobile)) {
        gap: 12px;
    }
}
</style>
